module.exports = __webpack_public_path__ + "img/nl-logo.57a19d82.svg";